<template>
  <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="false" @close="handleClose">
    <div class="diaInner" id="diaInner">
      <h3 class="diainner_title">
        高处安全作业
        <div class="diainner_title_num">编号：{{ message.no }}</div>
      </h3>
      <table border="1">
        <tr>
          <td class="title">申请单位</td>
          <td>{{ message.applicant?.contrName }}</td>
          <!-- <td class="title">申请人</td>
          <td>{{ getUserName(message.applyUserId) }}</td> -->
          <td class="title">作业申请时间</td>
          <td>{{ message.applyTime }}</td>
        </tr>

        <tr>
          <td class="title">作业地点</td>
          <td>{{ message.place }}</td>
          <td class="title">作业内容</td>
          <td>{{ message.businessJson.content }}</td>
        </tr>
        <tr>
          <td class="title">作业高度</td>
          <td>{{ message.businessJson.height }}</td>
          <td class="title">高处作业级别</td>
          <td>{{ getRiskGrade(message.businessJson.riskGrade) }}</td>
        </tr>
        <!-- <tr>
          <td class="title">作业高度</td>
          <td>{{ message.businessJson.height }}</td>
          <td class="title">作业类别</td>
          <td>{{ message.businessJson.category }}</td>
        </tr> -->
        <tr>
          <td class="title">作业单位</td>
          <td>{{ message.businessJson.workUnit }}</td>
          <td class="title">监护人</td>
          <td>{{ getUserName(message.businessJson.guardianId) }}</td>
        </tr>
        <tr>
          <td class="title">作业人</td>
          <td>{{ getUserName(message.jobExecutorEmpId) }}</td>
          <td class="title">作业负责人</td>
          <td>{{ getUserName(message.applyUserId) }}</td>
        </tr>
        <tr>
<!--          <td class="title">涉及的其他特殊作业</td>
          <td>{{ message.businessJson.tszy }}</td>-->
          <td class="title">涉及的其他特殊作业安全作业证编号</td>
          <td :colspan="7" >{{ message.businessJson.tszyzno }}</td>
        </tr>
        <tr>
          <td class="title">风险辨识结果</td>
          <td :colspan="3" class="keepLeft">{{ message.businessJson.hi }}</td>
        </tr>
<!--        <tr>
          <td class="title" :colspan="1">涉及的其他特殊作业及编号</td>
          <td :colspan="7">{{ formatPreWorkInfo() }}</td>
        </tr>-->
        <tr>
          <td class="title">作业实施时间</td>
          <td :colspan="3">{{ message.planStartTime }} - {{ message.planEndTime }}</td>
        </tr>
        <tr>
          <td class="title">序号</td>
          <td class="title">安全措施</td>
          <td class="title">是否涉及</td>
          <td class="title">确认人</td>
        </tr>
        <tr v-for="(item3, index3) in message.businessJson.sms" :key="index3 + '-' + item3.confirmorId">
          <td>{{ index3 + 1 }}</td>
          <td class="keepLeft">{{ item3.measures }}</td>
          <td>{{ item3.isInvolve == 1 ? '是' : '否' }}</td>
          <td><i v-html="getSignatureImg(item3.orderNo, 40)" /></td>
        </tr>
        <tr>
          <td class="title">安全交底人</td>
          <td>{{ getUserName(message.businessJson.aqjdrId) }}</td>
          <td class="title">接受交底人</td>
          <td>{{ getUserName(message.businessJson.jsjdrId) }}</td>
        </tr>
        <tr>
          <td :colspan="4">
            <div class="fireplayidea_title">作业负责人意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.companyChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.companyChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.companyChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="4">
            <div class="fireplayidea_title">所在单位意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.branchChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.branchChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.branchChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="4">
            <div class="fireplayidea_title">审核部门意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.auditChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.auditChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.auditChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="4">
            <div class="fireplayidea_title">审批部门意见</div>
            <div class="fireplayidea_cont">{{ message.businessJson.approveChargerComment }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(message.businessJson.approveChargerOrder, 60)" /></span>
              <span>签字时间：{{ message.businessJson.approveChargerTime }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td :colspan="4">
            <div class="fireplayidea_title">完工验收</div>
            <div class="fireplayidea_cont">{{ message.acceptanceOpinion }}</div>
            <div class="fireplayidea_right">
              <span>签字：<i v-html="getSignatureImg(0, 60)" /></span>
              <span>签字时间：{{ message.acceptanceTime }}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <span slot="footer" class="diaFooter">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button v-if="!isWork" type="primary" v-print="'#diaInner'" size="small">打 印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import signatureImg from "@/assets/img/签字.png";

export default {
  name: 'blindBoard',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    userList: {
      type: Array,
      default: []
    },
    riskGradeList: {
      type:Array,
      default:[
        {
          id: 0,
          name: "A类I级"
        },
        {
          id: 1,
          name: "A类II级"
        },
      ]
    },
    message: {
      type: Object,
      default: {}
    },
    isWork: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  methods: {
    formatPreWorkInfo() {
      if (!this.message.preWorkInfo) {
        return
      }
      let str = []
      let data = JSON.parse(this.message.preWorkInfo)
      for (var i = 0; i < data.length; i++) {
        let element = data[i]
        str.push(`${element.name}(${element.no})`)
      }
      str = str.join(',')
      return str
    },
    handleClose() {
      this.$emit('componentResult', false)
    },
    getUserName(id) {
      for (let i in this.userList) {
        if (Number(id) === this.userList[i].id) {
          return this.userList[i].name
        }
      }
    },
    getRiskGrade(id){
      for (let i in this.riskGradeList) {
        console.log(this.riskGradeList[i])
        if (Number(id) === this.riskGradeList[i].id) {
          return this.riskGradeList[i].name
        }
      }
    },
    getSignatureImg(orderNum, height = 40) {
      let signatureImg = require('@/assets/img/签字.png');
      let signatureImgHeight = 'auto';
      for (let i in this.message.reviewContentJson) {
        if (orderNum === this.message.reviewContentJson[i].orderNum) {
          let img = this.message.reviewContentJson[i].signatureImg;
          if (img) {
            signatureImg = img;
            signatureImgHeight = height + 'px'
          }
        }
      }

      return '<img style="height: ' + signatureImgHeight + '" src="' + signatureImg + '"/>';
    },
  }
}
</script>

<style src="./commonTable.css" scoped></style>

<style>
.diaInner {
  width: 1020px;
  margin: auto;
}

table {
  width: 1020px;
}

td {
  width: 150px;
}

.diainner_title {
  text-align: center;
  font-size: 28px;
  position: relative;
}

.diainner_title .diainner_title_num {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 14px;
  font-weight: normal;
}

.fireplayidea_title {
  font-size: 14px;
  text-align: left;
  font-weight: bold;
}

.fireplayidea_cont {
  line-height: 22px;
  text-align: left;
  margin: 10px 0;
}

.fireplayidea_right {
  text-align: right;
}

.fireplayidea_right span {
  margin-left: 10px;
  width: 220px;
  display: inline-block;
  text-align: left;
}
</style>